<template>
	<router-view></router-view>
</template>
<script>
//SSO, Direct Login 처리를 위한 빈 껍떼기 화면
export default {};
</script>
<style></style>
